import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContentTemplate,
  Divider,
  HeaderInput,
  SectionHeader,
  SingleSelectionRadio,
} from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../../../api-refactored/user/useGetUserAuthorities';
import CandidateAppealAccessList from './CandidateAppealAccessList';
import CoordinatorAppealAccessList from './CoordinatorAppealAccessList';

const OpsAdminAppealAccessGrantTable = () => {
  const [selectedAccountType, setSelectedAccountType] = useState<string>('candidates');

  const { t } = useTranslation();

  const { data: userAuthoritiesData = [] } = useGetUserAuthorities();
  const isEnableCreate = userAuthoritiesData.includes(
    AUTHORITY_NAMES.CP_ADMIN_GRANT_APPEAL_UNIQUE_LINK_CREATE
  );

  const onTypeChange = (currentType: string) => {
    setSelectedAccountType(currentType);
  };

  return (
    <>
      <ContentTemplate type="full">
        <SectionHeader title={t('admin->>UniqueLink.AccountDetails')} />
        <HeaderInput
          label={t('admin->>UniqueLink.AccountType')}
          input={
            <SingleSelectionRadio
              color="primary"
              value={selectedAccountType}
              onChange={(event) => {
                onTypeChange(event.target.value);
              }}
              data={[
                { label: t('admin->>UniqueLink.Candidate'), value: 'candidates' },
                { label: t('admin->>UniqueLink.Coordinator'), value: 'coordinators' },
              ]}
            />
          }
          topBottom
          alignCenter={false}
        />

        {selectedAccountType === 'candidates' && (
          <>
            <Divider />
            <CandidateAppealAccessList
              key={`${selectedAccountType}`}
              isEnableCreate={isEnableCreate}
            />
          </>
        )}
        {selectedAccountType === 'coordinators' && (
          <>
            <Divider />
            <CoordinatorAppealAccessList
              key={`${selectedAccountType}`}
              isEnableCreate={isEnableCreate}
            />
          </>
        )}
      </ContentTemplate>
    </>
  );
};
export default OpsAdminAppealAccessGrantTable;
